module.exports = __webpack_public_path__ + "img/about_img01.9bd591ad.png";